import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TimeLogsData } from '../../models/time-log';

@Component({
  selector: 'app-time-log-table-dialog',
  templateUrl: './time-log-table-dialog.component.html',
  standalone: false,
})
export class TimeLogTableDialogComponent {
  dialogData = inject<TimeLogsData>(MAT_DIALOG_DATA);
}
